import { render, staticRenderFns } from "./DxBpas.vue?vue&type=template&id=2317f2b3&scoped=true&"
import script from "./DxBpas.vue?vue&type=script&lang=js&"
export * from "./DxBpas.vue?vue&type=script&lang=js&"
import style0 from "./DxBpas.vue?vue&type=style&index=0&id=2317f2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317f2b3",
  null
  
)

export default component.exports